export const INTERCEPT_HERO = {
  badge: "INTERCEPT PROTOCOL // AGENCY BRIEFING",
  headline:
    "If your clients aren't running FractoLabs, our infrastructure is already intercepting their leads.",
  headlineLine1: "If your clients aren't running FractoLabs,",
  headlineLine2Lead: "our infrastructure is already ",
  headlineLine2Accent: "intercepting their leads.",
  subline:
    "Every after-hours click your campaigns buy can fund a competitor's client. If your client's stack doesn't respond in seconds, you eat the churn. Not them.",
  cta: "See How It Works",
  ctaTarget: "leaked-lead",
};
